import { memo, useCallback } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzModal, BzModalBody, BzModalFooter } from '../../components';
import { handleModal } from '../../redux/actions/modals';
import { useNavigate } from 'react-router';



const GuestUserProfileModal = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const modals = useSelector(state => state?.modals?.modals);

    const onHide = () => {
        dispatch(handleModal([{ "GUEST_USER_PROFILE_MODAL": false }]));
    };

    const handleGuestRegister = () => {
        dispatch(handleModal([{ "GUEST_USER_PROFILE_MODAL": false }]));
        navigate('/register');
    };

    const logoutHandler = useCallback(() => {
        dispatch(handleModal([{ 'USER_LOG_OUT_CONFIRMATION_MODAL': true }]));
    }, [dispatch]);

    return (
        <BzModal c show={modals['GUEST_USER_PROFILE_MODAL']} onHide={onHide} id="TopModal" role="dialog" aria-hidden="true">
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 my-3'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-medium font-size6 color-text'>Register or Login to access this feature</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-outline me-3' onClick={onHide}>Skip</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary me-3' onClick={logoutHandler}>Login</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary' onClick={handleGuestRegister}>Register</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(GuestUserProfileModal);
